import React from 'react'
import { Translate } from 'react-redux-i18n'
// import { Observable } from 'rxjs'
import moment from 'moment-timezone'
// import { MiddlewareAPI } from 'redux'
// import { Epic } from 'redux-observable'
import { PriceExtended, PricesExtended, TradeObject } from '@bdswiss/mt4-connector'

import {
  ChartingLibraryWidgetConstructor,
  IChartingLibraryWidget,
  IChartWidgetApi,
} from '../lib/charting_library/types/charting_library'
import { MT4DatafeedBase } from '../lib/charting_library/datafeed/mt4-datafeed-base'
import { /* RootState, */ ChartMode, TradingPane, PositionsInputs, AppTheme } from '../types'
// import { APPLY_POST_COMMAND } from '../constants'
// import { ApplyPostCommand } from '../actions/commonActions'
// import { checkTradingHours } from '../utils/common-utils'
import { ChartSignal } from '../lib/charting_library/signals/ChartSignal'
import { ChartPositions } from '../lib/charting_library/positions/ChartPositions'
import { setCookie } from '../utils/cookie-utils'

const loadingImage = require('../images/spinner.gif').default

declare global {
  const TradingView: ChartingLibraryWidgetConstructor
}

type Asset = PriceExtended & { label: string }

export interface Props {
  appTheme: AppTheme
  symbol: string
  resolution: string
  timeframe: string
  type: number // per TradingView specs
  locale: string
  chartMode: ChartMode
  positions: TradeObject[]
  pendingOrders: TradeObject[]
  positionsInputs: PositionsInputs
  tradingPane: TradingPane
  assets: PricesExtended
  visibleRange?: { from: number; to: number; interval: string }
  positionsOpened?: boolean
  selectedPosition?: number
  positionExpanded?: boolean
  selectedOrder?: number
  orderExpanded?: boolean
  signal?: any
  refreshChart?: boolean
  onChangeSymbol: (symbol: string) => void
  onSelectPosition: (order: number, expanded?: boolean) => void
  onChartReady: () => void
  onInputStopLoss: (order: number, value: number) => void
  onInputTakePorfit: (order: number, value: number) => void
  onInputPrice: (order: number, value: number) => void
  onSetStopLoss: (value: number) => void
  onSetTakePorfit: (value: number) => void
  onSetPrice: (value: number) => void
}

export interface State {
  prevType: number
  visibleRange: { from: number; to: number; timeScale: number }
}

const TradingChart = (props: Props) => {
  return <TradingChartContent {...props} />
}
// let chartComponent: TradingChartContent
// let propagatedExternally: boolean = false

// export const applyPostCommandEpic: Epic<ApplyPostCommand, RootState> = (
//   action$,
//   state: MiddlewareAPI<RootState>
// ) =>
//   action$.ofType(APPLY_POST_COMMAND).mergeMap(() => {
//     propagatedExternally = true
//     chartComponent.updateResolutionVisibleRange()
//     // chartComponent.updateVisibleRange();
//     return Observable.empty()
//   })

class TradingChartContent extends React.Component<Props, State> {
  private chart!: IChartWidgetApi
  private tvWidget!: IChartingLibraryWidget
  // private rangeSynced: boolean = true;
  private chartDatafeed = new MT4DatafeedBase()
  private chartSignal = new ChartSignal()
  private chartPositions = new ChartPositions()
  private pineJS: any

  constructor(props: Props) {
    super(props)
    // chartComponent = this
    this.state = {
      prevType: 1,
      visibleRange: { from: 0, to: 0, timeScale: 0 },
    }
  }

  public render() {
    return (
      <div className="chart-wrapper">
        <div id="tv_chart_spinner" className="chart-spinner">
          <div className="spinner">
            <img alt="Loading..." src={loadingImage} />
          </div>
        </div>
        <div id="tv_chart_container" className="chart-wrapper" style={{ opacity: '0' }} />
        {this.props.assets[this.props.symbol] && (
          <div className="tradingview-attribution-link-wrap">
            <a
              rel="noreferrer"
              target="_blank"
              href={`https://www.tradingview.com/symbols/${
                this.props.assets[this.props.symbol]['normalizedSymbol']
              }`}
            >
              <Translate
                value={'tradingViewAttributionLinkText'}
                symbol={(this.props.assets[this.props.symbol] as Asset).label}
              />
            </a>
          </div>
        )}
      </div>
    )
  }

  public componentDidMount() {
    this.configurateChart()
  }

  public componentDidUpdate(prevProps: Props, prevState: State) {
    const { chartMode, appTheme, symbol, refreshChart } = this.props
    // only update chart if the data has changed
    if (prevProps.appTheme !== appTheme) {
      this.applyChartTheme(appTheme)
    }
    if (prevProps.symbol !== symbol) {
      if (this.chart) {
        this.chartPositions.clearPositions()
        this.chart.setSymbol(symbol, () => {
          this.chartPositions.displayPositions()
        })
      }
    } else if (prevProps.refreshChart !== refreshChart && refreshChart === true) {
      const resetted = this.chartDatafeed.resetCache()
      if (resetted) {
        this.chart?.resetData()
      } else {
        this.removeChart()
        this.configurateChart()
      }
    } else if (
      prevProps.chartMode !== chartMode ||
      (chartMode === 'open' && prevProps.positions !== this.props.positions) ||
      (chartMode === 'pending' && prevProps.pendingOrders !== this.props.pendingOrders) ||
      ((!isNaN(prevProps.selectedPosition as number) ||
        !isNaN(this.props.selectedPosition as number)) &&
        prevProps.selectedPosition !== this.props.selectedPosition) ||
      ((!isNaN(prevProps.selectedOrder as number) || !isNaN(this.props.selectedOrder as number)) &&
        prevProps.selectedOrder !== this.props.selectedOrder) ||
      prevProps.positionExpanded !== this.props.positionExpanded ||
      prevProps.orderExpanded !== this.props.orderExpanded ||
      prevProps.tradingPane !== this.props.tradingPane
    ) {
      this.chart && this.chartPositions.displayPositions()
    }
    if (prevProps.visibleRange !== this.props.visibleRange) {
      this.updateResolutionVisibleRange()
    }
  }

  public componentWillUnmount() {
    this.removeChart()
  }

  public updateResolutionVisibleRange() {
    try {
      if (this.chart && this.props.visibleRange) {
        const { interval } = this.props.visibleRange
        // this.rangeSynced = false;
        if (this.chart.resolution() !== interval) {
          this.chart.setResolution(interval, () => void true)
        } else {
          // this.updateVisibleRange()
        }
      }
    } catch (e) {
      console.log(`Error updating chart resolution: ${e.message}`)
    }
  }

  private applyChartTheme(theme: AppTheme) {
    try {
      // const chartDocElement = this.tvWidget._getIFrameElement().contentDocument.documentElement
      if (theme === 'Dark') {
        // chartDocElement.classList.add('theme-dark')
        this.tvWidget.applyOverrides({
          'paneProperties.background': '#000000',
          'scalesProperties.backgroundColor': '#000000',
          'paneProperties.vertGridProperties.color': '#555',
          'paneProperties.horzGridProperties.color': '#555',
        })
      } else {
        // chartDocElement.classList.remove('theme-dark')
        this.tvWidget.applyOverrides({
          'paneProperties.background': '#ffffff',
          'scalesProperties.backgroundColor': '#ffffff',
          'paneProperties.vertGridProperties.color': '#f0f5f8',
          'paneProperties.horzGridProperties.color': '#f0f5f8',
        })
      }
      this.tvWidget.changeTheme(theme)
    } catch (e) {
      console.log(`Error applying chart theme: ${e.message}`)
    }
  }

  // private updateVisibleRange() {
  //   const currentRange = this.chart.getVisibleRange()
  //   const { from, to } = this.props.visibleRange!
  //   if (from !== currentRange.from || to !== currentRange.to) {
  //     this.state.visibleRange.from = from
  //     this.state.visibleRange.to = to
  //     this.chart.setVisibleRange({ from, to })
  //     // console.log(`[${moment(from*1000).format(`hh:mm`)}, ${moment(to*1000).format(`hh:mm`)}] ${(to- from) /60}`);
  //   }
  // }

  private configurateChart() {
    const { resolution, timeframe, locale, onChangeSymbol, appTheme, symbol } = this.props
    const { themeBgColor, themeGridColor } =
      appTheme === 'Light'
        ? { themeBgColor: '#ffffff', themeGridColor: '#f0f5f8' }
        : { themeBgColor: '#000000', themeGridColor: '#555' }
    const chartConfig = {
      // debug: true, // uncomment this line to see Library errors and warnings in the console
      theme: appTheme,
      timezone: moment.tz.guess(),
      fullscreen: true,
      autosize: true,
      symbol,
      interval: resolution,
      timeframe,
      container_id: 'tv_chart_container',
      // BEWARE: no trailing slash is expected in feed URL
      datafeed: this.chartDatafeed,
      library_path: '/assets/charting_library/',
      locale,
      // Regression Trend-related functionality is not implemented yet, so it's hidden for a while
      drawings_access: { type: 'black', tools: [{ name: 'Regression Trend' }] },
      disabled_features: [
        'use_localstorage_for_settings',
        'header_saveload',
        'header_compare',
        'header_symbol_search',
      ], // 'header_screenshot'],//'left_toolbar'],
      // enabled_features: ['study_templates'],
      favorites: {
        intervals: ['1', '15', '30', '60', '240', '1D'],
        chartTypes: ['Candles', 'Line'],
      },
      // toolbar_bg: themeBgColor,
      // loading_screen: { backgroundColor: themeBgColor },
      overrides: {
        'paneProperties.background': themeBgColor,
        'scalesProperties.backgroundColor': themeBgColor,
        'paneProperties.vertGridProperties.color': themeGridColor,
        'paneProperties.horzGridProperties.color': themeGridColor,
      },
      custom_css_url: 'css/custom.css',
      custom_indicators_getter: (pineJS: any) => {
        this.pineJS = pineJS
        // console.trace()
        return Promise.resolve([])
      },
    }
    try {
      const widget = (this.tvWidget = new (TradingView as any).widget(chartConfig))
      // const chartIFrame = this.tvWidget._getIFrameElement()
      // chartIFrame.onload = () => {
      //   this.applyChartTheme(appTheme)
      //   document.getElementById('tv_chart_spinner')!.style.display = 'none'
      //   document.getElementById('tv_chart_container')!.style.opacity = '1'
      // }
      widget.onChartReady(() => {
        document.getElementById('tv_chart_spinner')!.style.display = 'none'
        document.getElementById('tv_chart_container')!.style.opacity = '1'
        this.applyChartTheme(appTheme)
        this.props.onChartReady()
        this.chart = widget.activeChart()

        this.chartSignal.initChart(
          this.tvWidget,
          this.chartDatafeed.symbolsStorage.symbolsInfo[this.props.symbol]!,
          this.pineJS
        )

        this.chartPositions.initChart(this.chart)

        this.chart.onIntervalChanged().subscribe(null, (interval: any, obj: any) => {
          setCookie('currentResolution', interval)
          // this.updateVisibleRange();
          if (/^\d+S$/.test(this.chart.resolution())) {
            this.setState((state) => Object.assign(state, { type: this.chart.chartType() }))
            this.chart.setChartType(2)
          } else {
            this.chart.setChartType(this.state.prevType)
          }
        })
        ;(this.chart.onSymbolChanged().subscribe as any)(null, (symbolInfo: any, obj: any) => {
          if (this.props.symbol !== symbolInfo.name) {
            if (this.props.signal === null) {
              onChangeSymbol(symbolInfo.name)
            }
          }
        })
        // this.chart.dataReady(()=>{
        //   console.log(`DATA READY: ${this.props.symbol}/${this.chart.resolution()}`)
        //   this.chartSignal.dataSubject.next({ symbol: this.props.symbol, resolution: this.chart.resolution()})
        // })
        // this.chart.onDataLoaded().subscribe(null, (data: any) => {
        this.chart.onDataLoaded().subscribe(null, () => {
          // console.log(`DATA LOADED: ${this.props.symbol}/${this.chart.resolution()}`)
          this.chartSignal.dataSubject.next({
            symbol: this.props.symbol,
            resolution: this.chart.resolution(),
          })
          //   // const {from, to} = this.chart.getVisibleRange();
          //   // const now = new Date().getTime() / 1000;
          //   // console.log('data loaded'+ data + `${from}, ${to}, ${from-to}, ${now}:${(now-from)/60}m ${(now-from)/60/60}h ${(now-from)/60/60/24}d`);
          //   if (propagatedExternally) {
          //     propagatedExternally = false
          //     // this.updateVisibleRange()
          //   }
        })

        this.chartPositions.displayPositions()
      })
    } catch (e) {
      console.log(`Chart initialization error: ${e.message}`)
    }
  }

  private removeChart() {
    try {
      this.tvWidget && this.tvWidget.remove()
    } catch (e) {
      console.log(`Error removing chart widget: ${e.message}`)
    }
  }
}

export default TradingChart
